module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/faq_hairmakeup_01_sp-87af3a0a8ec7348a93ea968ede492147.png";